// QHopen.js  
import QHopen from './QHopen.vue';
const ModalService = {
    install(Vue) {
        Vue.prototype.$QHopen = {
            url(url, width, height, closeBtnTop, closeBtnName) {
                // 使用闭包来存储模态框的实例  
                let modalInstance = new Vue({
                    render(h) {
                        // 传递 props 和其他需要的选项  
                        return h(QHopen, {
                            props: {
                                url,
                                width,
                                height,
                                closeBtnTop,
                                closeBtnName
                                // 可以添加其他 props 或事件  
                            },
                            on: {
                                // 可以监听组件内部发出的事件  
                                close: () => {
                                    // 当组件内部触发 close 事件时，销毁实例  
                                    modalInstance.$destroy();
                                    modalInstance.$el.remove();
                                    modalInstance = null;
                                },
                            },
                        });
                    },

                }).$mount();
                document.body.appendChild(modalInstance.$el);
                // 你可以在这里添加其他逻辑，如动画或过渡效果  
            },
            // 如果需要，可以添加其他方法，如检查模态框是否打开等  
        };
    },
};
export default ModalService;